import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'generic-component.select-picker-loading-text': {
    id: 'generic-component.select-picker-loading-text',
    defaultMessage: 'Loading...',
    description:
      'The text that is shown when the data for a select dropdown is still loading.'
  }
});
